import angular from 'angular';
import { changePageTitle } from 'auth/actions/session.actions';

export default angular.module('registrationRouting', []).config([
  '$stateProvider',
  ($stateProvider) => {
    $stateProvider
      .state('registration-complete', {
        parent: 'arw',
        url: '/retailer-complete-registration/:login/:password',
        template: '<complete-registration></complete-registration>',
        params: {
          hideMenu: true,
        },
      })
      .state('registration-secondaryUser', {
        parent: 'arw',
        url: '/retailer-register-secondary-user',
        template: '<div ui-view id="register-secondary-user" />',
        redirectTo: 'home-view',
      })
      .state('registration-primary', {
        parent: 'arw',
        url: '/retailer-primary-registration',
        template: '<self-registration></self-registration>',
        params: {
          hideMenu: true,
          pageTitle: [
            '$ngRedux',
            'gettextCatalog',
            ($ngRedux, gettextCatalog) => {
              $ngRedux.dispatch(changePageTitle(gettextCatalog.getString('Sign Up')));
            },
          ],
        },
      })
      .state('registration-chainRegistrationDisabled', {
        parent: 'arw',
        url: '/chain-disabled',
        template: '<self-registration-disabled></self-registration-disabled>',
        params: {
          hideMenu: true,
        },
      })
      .state('registration-confirmation', {
        parent: 'arw',
        url: '/retailer-primary-registration-confirmation',
        template: '<self-registration-confirmation></self-registration-confirmation>',
        params: {
          hideMenu: true,
        },
      })
      .state('registration-primaryConfirm', {
        parent: 'arw',
        url: '/retailer-primary-registration-confirm/:userId/:token',
        template: '<self-registration-confirm></self-registration-confirm>',
        params: {
          hideMenu: true,
        },
      });
  },
]);



// WEBPACK FOOTER //
// ./src/modules/registration/registration-routing-module.js